module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-sick"
  }, [(!_vm.item.shift && !_vm.item.times) ? _c('div', {
    staticClass: "empty is-visible"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('page.roster.tools.sick.needs_time')) + "\n    ")]) : _c('div', [(!_vm.user.billable && !_vm.$onduro.getConfig('hours.everyone')) ? _c('div', {
    staticClass: "box-note",
    staticStyle: {
      "font-size": "12px",
      "color": "#c9635b"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('page.roster.tools.sick.no_costs')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.payroll),
      expression: "user.payroll"
    }],
    staticClass: "box-note"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('page.roster.tools.sick.payroll_payment')) + "\n        ")]), _vm._v(" "), (_vm.$current.profile == 'SKO') ? _c('div', [_c('div', {
    staticClass: "box-note"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('page.roster.tools.sick.sko')) + "\n            ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.code),
      expression: "form.code"
    }],
    staticStyle: {
      "width": "280px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "code", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.codes), function(name, id) {
    return _c('option', {
      domProps: {
        "value": id
      }
    }, [_vm._v(_vm._s(name))])
  }), 0), _vm._v(" "), _c('error', {
    staticStyle: {
      "color": "#c9635b"
    },
    attrs: {
      "message": _vm.$v.message('code')
    }
  })], 1) : [(!_vm.user.payroll) ? _c('div', [(_vm.$onduro.hasModule('balances')) ? _c('div', [(_vm.user.balance && _vm.form.percentage != '100') ? _c('div', {
    staticClass: "box-note"
  }, [_vm._v(_vm._s(_vm.$t('page.roster.tools.sick.balance_note')))]) : _c('div', {
    staticClass: "box-note"
  }, [_vm._v(_vm._s(_vm.$t('page.roster.tools.sick.hint')))])]) : _c('div', {
    staticClass: "box-note"
  }, [_vm._v(_vm._s(_vm.$t('page.roster.tools.sick.hint')))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('page.roster.tools.sick.payment')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.percentage),
      expression: "form.percentage"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "percentage", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.percentages), function(percentage, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(percentage))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.$onduro.hasModule('costs') && _vm.user.costs && _vm.user.costs.length > 1) ? _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('label.cost')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.cost),
      expression: "form.cost"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "cost", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.user.costs), function(cost) {
    return _c('option', {
      domProps: {
        "value": cost.id
      }
    }, [_vm._v(_vm._s(cost.name))])
  }), 0)]) : _vm._e()], _vm._v(" "), (_vm.sick) ? _c('a', {
    staticClass: "unmark",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeSickness.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('page.roster.tools.sick.undo')))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "box-button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveSickness.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('page.roster.tools.sick.apply')))])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a8518de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/tools/Sick.vue
// module id = 601
// module chunks = 225